import clsx from "clsx";
import styled from "styled-components";

const Root = styled.span`
    display: inline-flex;
    align-items: center;

    &.img {
        height: 1em;
    }
`;

type Props = {
    icon: string;
    className?: string;
};

const LelyIconBase = (props: Props) => {
    const { icon, className } = props;

    const iconClassName = `lely-icon-${icon}`;

    return <Root className={clsx(className, iconClassName)} />;
};

export { LelyIconBase };
export type { Props as LelyIconBaseProps };
